module.exports = __webpack_public_path__ + "static/media/player_level_D.115aed74.png";